package music.jammers.client.shared.signin

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import androidx.compose.ui.Modifier
import dev.gitlive.firebase.Firebase
import dev.gitlive.firebase.auth.GoogleAuthProvider
import dev.gitlive.firebase.auth.auth
import kotlinx.coroutines.Dispatchers
import kotlinx.coroutines.launch
import kotlinx.coroutines.withContext
import music.jammers.client.shared.signin.models.AuthResponse
import music.jammers.client.shared.signin.models.GoogleAuthError
import org.jetbrains.compose.resources.DrawableResource

internal expect val GOOGLE_ACCESS_TOKEN: String?

const val TOKEN_NOT_REQUIRED = "token_not_required"

@Composable
internal expect fun GoogleLoginButton(
    onResponse: (AuthResponse) -> Unit,
    progress: Boolean,
    iconDrawable: DrawableResource,
    modifier: Modifier = Modifier,
)

@Composable
fun GoogleButton(
    onResponse: (AuthResponse) -> Unit,
    iconDrawable: DrawableResource,
    modifier: Modifier = Modifier,
) {
    val coroutineScope = rememberCoroutineScope()

    val progress = remember { mutableStateOf(false) }

    GoogleLoginButton(
        modifier = modifier,
        iconDrawable = iconDrawable,
        progress = progress.value,
        onResponse = { response ->
            when (response) {
                is AuthResponse.Success -> {
                    println("ON Success")
                    coroutineScope.launch(Dispatchers.Default) {
                        runCatching {
                            val auth = Firebase.auth

                            if (response.token != TOKEN_NOT_REQUIRED) {
                                auth.signInWithCredential(
                                    GoogleAuthProvider.credential(response.token, GOOGLE_ACCESS_TOKEN)
                                )
                            }

                            auth.currentUser?.getIdToken(true)?.let { token ->
                                withContext(Dispatchers.Main) {
                                    progress.value = true
                                    onResponse(AuthResponse.Success(token))
                                }
                            }
                        }.onFailure { throwable ->
                            println("fail: ${throwable.message}")
                            onResponse(
                                AuthResponse.Error(
                                    GoogleAuthError(0L, throwable.message ?: "Firebase error")
                                )
                            )
                        }
                    }
                }

                AuthResponse.Progress -> {
                    progress.value = true
                    onResponse(response)
                }

                else -> {
                    progress.value = false
                    onResponse(response)
                }
            }
        }
    )
}